cancelNotifyTimeout